import React, { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== "undefined") {
      return (
        localStorage.getItem("theme") === "dark" ||
        (!("theme" in localStorage) &&
          window.matchMedia("(prefers-color-scheme: dark)").matches)
      );
    }
    return false;
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (isDark) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [isDark]);

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      className="relative p-2.5 rounded-xl bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 shadow-md hover:shadow-lg active:scale-95 active:shadow-inner transition-all duration-200 border border-gray-100 dark:border-gray-700 flex items-center justify-center group"
      aria-label="Toggle Theme"
      title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
    >
      <div className="relative w-5 h-5 flex items-center justify-center overflow-hidden">
        <AnimatePresence mode="wait">
          {isDark ? (
            <motion.div
              key="moon"
              initial={{ y: 20, rotate: 90, opacity: 0 }}
              animate={{ y: 0, rotate: 0, opacity: 1 }}
              exit={{ y: -20, rotate: -90, opacity: 0 }}
              transition={{ duration: 0.3, ease: "backOut" }}
            >
              <Moon className="w-5 h-5 text-indigo-400 group-hover:text-indigo-300" />
            </motion.div>
          ) : (
            <motion.div
              key="sun"
              initial={{ y: 20, rotate: 90, opacity: 0 }}
              animate={{ y: 0, rotate: 0, opacity: 1 }}
              exit={{ y: -20, rotate: -90, opacity: 0 }}
              transition={{ duration: 0.3, ease: "backOut" }}
            >
              <Sun className="w-5 h-5 text-amber-500 group-hover:text-amber-400" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      
      {/* 3D Depth Layer */}
      <div className="absolute inset-x-0 -bottom-1 h-1 bg-gray-200 dark:bg-gray-900 rounded-b-xl opacity-0 group-active:opacity-0 transition-opacity" />
    </button>
  );
}
